import { useSelector } from 'react-redux';
import FJCreationPanel from './FJCreationPanel';
import { useCallback } from 'react';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import { useDispatch } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import PropTypes from 'prop-types';
import FJActionModal from '../../../redux/action/FJActionModal';
import { useMemo } from 'react';
import FJConstant from '../../../constants/FJConstant';
import FJAppConstant from '../../../constants/FJAppConstant';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';

const FJCreationPanelContainer = props => {
    useLocalStore();
    const { activeHeaderTabIndex = 0, hideCompare = false, isShowPresetImageBox = false, onRetry } = props;
    const dispatch = useDispatch();
    const creationList = useSelector(state => state.common.creationList);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const presetList = useSelector(state => state.AIVideoGenerator.presetList);
    const presetImageList = useSelector(state => state.textToImage.presetImageList);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const appType = useSelector(state => state.common.appType);
    const hideDownload = useMemo(
        () => taskStatus === FJConstant.ERROR || appType === FJAppConstant.IMAGE_TO_IMAGE,
        [taskStatus, appType],
    );

    const useHideCompare = useMemo(() => taskStatus === FJConstant.ERROR || hideCompare, [taskStatus, hideCompare]);

    const multiDownload = useCallback(
        (ids, source, callback) => {
            dispatch(FJActionCommon.multiDownloadAction(ids, source, callback));
        },
        [dispatch],
    );

    const onDownload = useCallback(
        (id, callback) => {
            multiDownload([id], 'creation', callback);
        },
        [multiDownload],
    );

    const onAddToMedia = url => {
        dispatch(FJActionEditPage.addToMediaLibraryAction(url, { from: 'generate' }));
    };

    const previewImage = data => {
        dispatch(FJActionModal.showPreviewModalDataAction({ data }));
    };

    const curCreationList = useMemo(() => {
        if (!isShowPresetImageBox) {
            // 物件擦除、舊照片修復、照片上色，创作区不需要显示图片
            if (
                appType === FJAppConstant.OBJECT_ERASER ||
                appType === FJAppConstant.PHOTO_RESTORATION ||
                appType === FJAppConstant.PHOTO_COLORIZE
            ) {
                return creationList.map(item => {
                    return { ...item, isLoading: true };
                });
            }

            return creationList;
        }
        if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
            return presetList.map(item => {
                return {
                    ...item,
                    width: 438,
                    height: 779,
                };
            });
        }
        return presetImageList.map(item => {
            return {
                ...item,
                width: 438,
                height: 779,
            };
        });
    }, [creationList, isShowPresetImageBox, presetImageList, presetList, appType]);

    const reGenerate = useCallback(
        id => {
            if (onRetry) onRetry(id);
            else dispatch(FJActionCommon.reGenerateAction(id));
        },
        [dispatch],
    );

    const isShowBlankInVideoPanel =
        appType === FJAppConstant.IMAGE_TO_IMAGE ||
        appType === FJAppConstant.IMAGE_ENHANCER ||
        appType === FJAppConstant.FACE_SWAP ||
        appType === FJAppConstant.CLOTHES_CHANGER;

    return (
        <FJCreationPanel
            appType={appType}
            active={activeHeaderTabIndex === headerTabIndex}
            creationList={curCreationList}
            previewImage={previewImage}
            onDownload={onDownload}
            onAddToMedia={onAddToMedia}
            hideCompare={useHideCompare}
            hideDownload={hideDownload}
            isShowPresetImageBox={isShowPresetImageBox}
            isShowAddToMediaButton={false}
            reGenerate={reGenerate}
            isShowBlankInVideoPanel={isShowBlankInVideoPanel}
        />
    );
};

FJCreationPanelContainer.propTypes = {
    activeHeaderTabIndex: PropTypes.number,
    hideCompare: PropTypes.bool,
    isShowPresetImageBox: PropTypes.bool,
    onRetry: PropTypes.func,
};

export default FJCreationPanelContainer;
